/** The most saturated, not-white, not-black color in a logo file (screen 3 prefill). Resolves null when unsure. */
export function logoColor(file) {
    return new Promise((resolve) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            try {
                const c = document.createElement("canvas");
                c.width = c.height = 40;
                const ctx = c.getContext("2d");
                ctx.drawImage(img, 0, 0, 40, 40);
                const { data } = ctx.getImageData(0, 0, 40, 40);
                const buckets = {};
                for (let i = 0; i < data.length; i += 4) {
                    const [r, g, b, a] = [data[i], data[i + 1], data[i + 2], data[i + 3]];
                    if (a < 128) continue;
                    const max = Math.max(r, g, b), min = Math.min(r, g, b);
                    const sat = max === 0 ? 0 : (max - min) / max;
                    if (sat < 0.35 || max < 40 || min > 230) continue;
                    const key = `${r >> 4}-${g >> 4}-${b >> 4}`;
                    const k = buckets[key] || (buckets[key] = { n: 0, r: 0, g: 0, b: 0 });
                    k.n += 1; k.r += r; k.g += g; k.b += b;
                }
                const best = Object.values(buckets).sort((x, y) => y.n - x.n)[0];
                if (!best || best.n < 8) return resolve(null);
                const hex = (v) => Math.round(v / best.n).toString(16).padStart(2, "0");
                resolve(`#${hex(best.r)}${hex(best.g)}${hex(best.b)}`);
            } catch { resolve(null); }
            finally { URL.revokeObjectURL(url); }
        };
        img.onerror = () => resolve(null);
        img.src = url;
    });
}
